"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCarouselScrollContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CarouselScrollContainerMixin = require("../../mixins/components/CarouselScrollContainerMixin");
var _Flex = require("../Flex/Flex");
var StyledCarouselScrollContainer = /*#__PURE__*/(0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "StyledCarouselScrollContainer",
  componentId: "c11n-8-107-0__sc-1jrjjf3-0"
})(["", ""], _CarouselScrollContainerMixin.CarouselScrollContainerMixin);
exports.StyledCarouselScrollContainer = StyledCarouselScrollContainer;